(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-featured-by"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMarquee = (section) => {
      if (!section || section.dataset.marqueeInitialized == 'true') {
        return;
      }

      const marquee = section.querySelector('.homepage-featured-by__marquee');
      const track = section.querySelector('.homepage-featured-by__track');

      if (!marquee || !track) {
        return;
      }

      section.dataset.marqueeInitialized = 'true';

      let animationFrame = null;
      let lastTimestamp = null;
      let currentSpeed = Number(section.dataset.scrollSpeed) || 36;
      let targetSpeed = Number(section.dataset.scrollSpeed) || 36;
      let baseSpeed = Number(section.dataset.scrollSpeed) || 36;
      let offset = 0;
      let momentumVelocity = 0;
      let isDragging = false;
      let activePointerId = null;
      let dragStartX = 0;
      let dragStartOffset = 0;
      let lastDragX = 0;
      let lastDragTime = 0;
      let dragVelocity = 0;

      const isMobileViewport = () => {
        return window.matchMedia('(max-width: 768px)').matches;
      };

      const normalizeOffset = (loopWidth) => {
        if (loopWidth <= 0) {
          return;
        }

        while (offset <= -loopWidth) {
          offset += loopWidth;
        }

        while (offset > 0) {
          offset -= loopWidth;
        }
      };

      const updateBaseSpeed = () => {
        const configuredSpeed = Number(section.dataset.scrollSpeed) || 36;

        if (isMobileViewport()) {
          baseSpeed = configuredSpeed * 0.6111111111;
        } else {
          baseSpeed = configuredSpeed;
        }

        if (!isDragging) {
          if (marquee.matches(':hover') && !isMobileViewport()) {
            targetSpeed = baseSpeed * 0.18;
          } else {
            targetSpeed = baseSpeed;
          }
        }
      };

      const getLoopWidth = () => {
        return track.scrollWidth / 3;
      };

      const updateTrackPosition = () => {
        const loopWidth = getLoopWidth();

        normalizeOffset(loopWidth);

        if (loopWidth > 0) {
          track.style.transform = `translate3d(${offset}px, 0, 0)`;
        }
      };

      const handlePointerDown = (event) => {
        if (event.pointerType == 'mouse' && event.button !== 0) {
          return;
        }

        const loopWidth = getLoopWidth();

        if (loopWidth <= 0) {
          return;
        }

        isDragging = true;
        activePointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartOffset = offset;
        lastDragX = event.clientX;
        lastDragTime = event.timeStamp;
        dragVelocity = 0;
        momentumVelocity = 0;
        currentSpeed = 0;
        targetSpeed = 0;
        marquee.classList.add('is-dragging');
        marquee.setPointerCapture(event.pointerId);

        if (event.pointerType == 'mouse') {
          event.preventDefault();
        }
      };

      const handlePointerMove = (event) => {
        if (!isDragging || event.pointerId != activePointerId) {
          return;
        }

        const deltaX = event.clientX - dragStartX;
        const deltaTime = event.timeStamp - lastDragTime;

        offset = dragStartOffset + deltaX;

        if (deltaTime > 0) {
          dragVelocity = (event.clientX - lastDragX) / (deltaTime / 1000);
        }

        lastDragX = event.clientX;
        lastDragTime = event.timeStamp;
        updateTrackPosition();
        event.preventDefault();
      };

      const finalizeDrag = (pointerId) => {
        if (!isDragging || pointerId != activePointerId) {
          return;
        }

        const releasedPointerId = activePointerId;

        isDragging = false;
        activePointerId = null;
        momentumVelocity = Math.max(Math.min(dragVelocity, 1600), -1600);
        dragVelocity = 0;
        marquee.classList.remove('is-dragging');

        if (marquee.hasPointerCapture && marquee.hasPointerCapture(releasedPointerId)) {
          marquee.releasePointerCapture(releasedPointerId);
        }

        if (marquee.matches(':hover') && !isMobileViewport()) {
          targetSpeed = baseSpeed * 0.18;
        } else {
          targetSpeed = baseSpeed;
        }
      };

      const handlePointerEnd = (event) => {
        finalizeDrag(event.pointerId);
      };

      const handleLostPointerCapture = (event) => {
        finalizeDrag(event.pointerId);
      };

      const animate = (timestamp) => {
        if (lastTimestamp == null) {
          lastTimestamp = timestamp;
        }

        const deltaTime = (timestamp - lastTimestamp) / 1000;
        lastTimestamp = timestamp;

        currentSpeed += (targetSpeed - currentSpeed) * Math.min(1, deltaTime * 4);

        const loopWidth = getLoopWidth();

        if (loopWidth > 0) {
          if (!isDragging) {
            offset -= currentSpeed * deltaTime;

            if (Math.abs(momentumVelocity) > 1) {
              offset += momentumVelocity * deltaTime;
              momentumVelocity *= Math.exp(-4 * deltaTime);
            } else {
              momentumVelocity = 0;
            }
          }

          normalizeOffset(loopWidth);
          track.style.transform = `translate3d(${offset}px, 0, 0)`;
        }

        animationFrame = window.requestAnimationFrame(animate);
      };

      marquee.addEventListener('mouseenter', () => {
        targetSpeed = baseSpeed * 0.18;
      });

      marquee.addEventListener('mouseleave', () => {
        targetSpeed = baseSpeed;
      });

      marquee.addEventListener('pointerdown', handlePointerDown);
      marquee.addEventListener('pointermove', handlePointerMove);
      marquee.addEventListener('pointerup', handlePointerEnd);
      marquee.addEventListener('pointercancel', handlePointerEnd);
      marquee.addEventListener('lostpointercapture', handleLostPointerCapture);
      window.addEventListener('pointerup', handlePointerEnd);
      window.addEventListener('pointercancel', handlePointerEnd);

      window.addEventListener('resize', updateBaseSpeed, { passive: true });

      updateBaseSpeed();
      currentSpeed = baseSpeed;
      targetSpeed = baseSpeed;
      animationFrame = window.requestAnimationFrame(animate);

      section.addEventListener('shopify:section:unload', () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
        }

        marquee.removeEventListener('pointerdown', handlePointerDown);
        marquee.removeEventListener('pointermove', handlePointerMove);
        marquee.removeEventListener('pointerup', handlePointerEnd);
        marquee.removeEventListener('pointercancel', handlePointerEnd);
        marquee.removeEventListener('lostpointercapture', handleLostPointerCapture);
        window.removeEventListener('pointerup', handlePointerEnd);
        window.removeEventListener('pointercancel', handlePointerEnd);
      });
    };

    document.querySelectorAll('.homepage-featured-by').forEach(initializeMarquee);

    document.addEventListener('shopify:section:load', (event) => {
      initializeMarquee(event.target.querySelector('.homepage-featured-by'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-application-video"] && !Shopify.designMode) return;
  try {
    
  let cancelPendingScrollPlay = () => {};

  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    if (!event.target.matches('.product-application-video__player')) return;
    event.target.closest('.product-application-video')?.classList.add('has-played');
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-application-video-link]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    cancelPendingScrollPlay();
    const video = target.querySelector('video');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.scrollIntoView({ behavior: 'instant', block: 'center' });
      if (video) video.play().catch(() => {});
      return;
    }

    let playTimer;
    const onScroll = () => {
      window.clearTimeout(playTimer);
      playTimer = window.setTimeout(() => {
        cancelPendingScrollPlay();
        if (video) video.play().catch(() => {});
      }, 180);
    };
    cancelPendingScrollPlay = () => {
      window.clearTimeout(playTimer);
      window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    onScroll();
  });

  } catch(e) { console.error(e); }
})();
})();
